import { ICategorizedResponse, Id } from "redmond";

export const findFlatIndexInCategories = (
  categories: ICategorizedResponse[],
  targetId: Id
): number => {
  let flatIndex = 0;
  for (const category of categories) {
    for (const result of category.results) {
      if (result.id === targetId) {
        return flatIndex;
      }
      flatIndex++;
    }
  }
  return 0;
};
